<template>

    <!-- Page header -->
	<div class="page-header page-header-light shadow">

		<!-- breadcrumb -->
		<div class="page-header-content d-lg-flex">
			<div class="d-flex">
				<h4 class="page-title mb-0">
					<router-link href="#" class="mb-xs-1 text-dark cursor-pointer" :to="'Dashboard'"><i class="icon-arrow-left52 me-1"></i></router-link>
					<a href="#" class="hidden-xs text-dark fw-semibold cursor-pointer"> Preferenze </a> 
					<span class="hidden-xs ms-1">\</span>
                    <span class="text-muted ms-1">Configurazione Footer </span>
                </h4>
				<a href="#page_header" class="hidden-lg btn btn-light align-self-center collapsed border-transparent rounded-pill p-0 ms-auto" data-bs-toggle="collapse">
					<i class="ph-caret-down collapsible-indicator ph-sm m-1"></i>
				</a>
            </div>
			<div class="collapse d-lg-block my-lg-auto ms-lg-auto text-center" id="page_header">
                <div class="d-sm-flex align-items-center mb-3 mb-lg-0 ms-lg-3">

					<div class="vr flex-shrink-0 my-2 mx-3"></div>

					<div class="d-inline-flex float-end mt-sm-0">
						<a href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill ms-2" v-on:click="$root.confTravelLingue(this.modulo)" title="Definizioni Lingua" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="ph-flag"></i>
						</a>
						<a href="#" class="btn btn-outline-pink btn-icon w-32px h-32px squared-pill ms-2" v-on:click="$root.help(this.modulo)" title="Help OnLIne" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="icon-question7 pink"></i>
						</a>
	                </div>
	            </div>
	        </div>
		</div>
		<!-- /breadcrumb -->

		<!-- Profile navigation -->
		<div class="navbar navbar-expand-lg border-top py-1">
			<div class="container-fluid">
				<ul class="nav navbar-nav flex-row flex-fill" role="tablist">
					<li class="nav-item me-1" role="presentation">
						<a class="navbar-nav-link navbar-nav-link-icon navbar-sm rounded cursor-pointer" :class="{active: activeTab == 'webowne-a'}" v-on:click="activeTab = 'webowne-a', getOpzioni(activeTab,idEnteCorrente)" data-bs-toggle="tab" aria-selected="true" role="tab" tabindex="-1">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="ph-list me-1"></i>Contenuti
							</div>
						</a>
					</li>
					<li class="nav-item me-1" role="presentation">
						<a class="navbar-nav-link navbar-nav-link-icon navbar-sm rounded cursor-pointer" :class="{active: activeTab == 'webowne-b'}" v-on:click="activeTab = 'webowne-b', getOpzioni(activeTab,idEnteCorrente)" data-bs-toggle="tab" aria-selected="false" role="tab">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="icon-magazine me-1"></i>Custom
							</div>
						</a>
					</li>
				</ul>
			</div>
		</div>
		<!-- /profile navigation -->	

	</div>
    <!-- /page header -->
    
    <!-- Content area -->
    <div class="content content-1 table-cms-wrapper">

		<div class="tab-content flex-1 order-2 order-lg-1">	

			<div class="tab-pane fade" id="webowne-a" :class="{'active show': activeTab == 'webowne-a'}">
        		<div class="card shadow mb-xs-3 mb-lg-0">
		            <div class="collapse show" id="collapse-all" style="">				
		                <div class="card-body pb-0">
                            <div class="alert alert-2 alert-secondary border-0"> 
			                    <div class="row">
			                        <div class="col-12 col-md-10 col-lg-10 mbx-1">
		                                <p style="padding: 0 2px; position:relative; top:5px;">
		                                    I campi contrassegnati in <span class="text-danger">rosso</span> sono <strong>Obbligatori</strong>. 
		                                    Inserire dati corretti e veritieri, la maggior parte sono pubblicati su documenti fiscali.
		                                </p>	  
		                            </div>                              
			                        <div class="col-12 col-md-2 col-lg-2 mbx-1 d-grid gap-2">
			                            <button type="submit" class="btn btn-primary btn-block float-end" v-if="$root.hasFunzionalita('CONF_FOOTER_UPDATE')" v-on:click="salvaOpzioni()"><i class="icon-floppy-disk me-2"></i>Salva Modifiche</button>
			                        </div>			
			                    </div>
						   </div>
		                </div>	
		            </div>

                    <div class="card-body box-card mt-0 mb-0" >
                        <div class="box-config" id="tableFixHead">
                            <div class="row ">
                                <div class="col-12">                
                                    <fieldset v-if="arrayOpzioniConfigurazione.length > 0">
                                        <legend class="font-weight-semibold mb-2">Contenuti del sito</legend>
                                        <ul class="nav nav-tabs nav-tabs-highlight">
                                            <li class="nav-item" v-for="testi in arrayOpzioniConfigurazione[0].opzioni" v-bind:key="testi.LABEL">
                                                <a :href="'#tab-'+testi.ID_OPZIONE_BASE" class="nav-link " :class="testi.CLASSE_CTRL" data-bs-toggle="tab" :id="'link_'+testi.ID_OPZIONE_BASE">{{ testi.ETICHETTA }}</a>
                                            </li>
                                        </ul>
                                        <div class="tab-content">
                                            <div class="tab-pane fade mt-2" :class="{'active show' : testi.CLASSE_CTRL == 'input-sm active' , '' : testi.CLASSE_CTRL == 'input-sm' }" v-for="testi in arrayOpzioniConfigurazione[0].opzioni" v-bind:key="testi.LABEL" :id="'tab-'+testi.ID_OPZIONE_BASE">
                                                <IControl :campo="testi" v-model="testi.VALORE" :inputgroup="testi.GROUP" :icon="testi.ICON"></IControl>
                                            </div>  
                                        </div>
                                    </fieldset>
                                </div>                    
                            </div> 
                        </div>
                    </div>
		        </div>
            </div> 

            <div class="tab-pane fade" :class="{'active show': activeTab == 'webowne-b'}">
                <div class="card shadow mb-0 mb-xs-1">
		            <div class="collapse show" id="collapse-all" style="">				
		                <div class="card-body pb-0">
                            <div class="alert alert-2 alert-secondary border-0"> 
			                    <div class="row">
			                        <div class="col-12 col-md-10 col-lg-10 mbx-1">
		                                <p style="padding: 0 2px; position:relative; top:5px;">
		                                    I campi contrassegnati in <span class="text-danger">rosso</span> sono <strong>Obbligatori</strong>. 
		                                    Inserire dati corretti e veritieri, la maggior parte sono pubblicati su documenti fiscali.
		                                </p>	  
		                            </div>                              
			                        <div class="col-12 col-md-2 col-lg-2 mbx-1 d-grid gap-2">
			                            <button type="submit" class="btn btn-primary btn-block float-end" v-if="$root.hasFunzionalita('CONF_FOOTER_UPDATE')" v-on:click="salvaOpzioni()"><i class="icon-floppy-disk me-2"></i>Salva Modifiche</button>
			                        </div>			
			                    </div>
						   </div>
		                </div>	
		            </div>

                    <div class="card-body box-card mt-0 mb-0">
                        <div class="box-config" id="tableFixHead">
                            <div class="row ">
                                <div class="col-12">
                                    <fieldset v-if="arrayOpzioniConfigurazione.length > 0">
                                        <legend class="font-weight-semibold mb-2">Contenuti custom</legend>
                                        <ul class="nav nav-tabs nav-tabs-highlight">
                                            <li class="nav-item" v-for="testi in arrayOpzioniConfigurazione[1].opzioni" v-bind:key="testi.LABEL">
                                                <a :href="'#tab-'+testi.ID_OPZIONE_BASE" class="nav-link " :class="testi.CLASSE_CTRL" data-bs-toggle="tab" :id="'link_'+testi.ID_OPZIONE_BASE">{{ testi.ETICHETTA }}</a>
                                            </li>
                                        </ul>
                                        <div class="tab-content">
                                            <div class="tab-pane fade mt-2" :class="{'active show' : testi.CLASSE_CTRL == 'input-sm active' , '' : testi.CLASSE_CTRL == 'input-sm' }" v-for="testi in arrayOpzioniConfigurazione[1].opzioni" v-bind:key="testi.LABEL" :id="'tab-'+testi.ID_OPZIONE_BASE">
                                                <IControl :campo="testi" v-model="testi.VALORE" :inputgroup="testi.GROUP" :icon="testi.ICON"></IControl>
                                            </div>  
                                        </div>
                                    </fieldset>
                                </div>                     
                            </div>                    
                        </div>
                    </div>
                </div>
            </div>


        </div>

    </div>

</template>



<script>   

import IControl from '@/components/utils/IControl.vue' 


export default {
    name:"ConfFooter", 

    components:{
        IControl,

    },

    data: function () {
        return {   
			apiStartup:'core/opzioni/ente',
            filters:global.filters,
            GLOBAL_IMAGES_PATH:'',
			anno:new Date().getFullYear(),
            arrayFunzionalita: new Array(),
            searchFunzionalita:{

            },

            opzioneSelezionata:{},
			activeTab: 'webowne-a',
            idEnteCorrente:0,
            arrayOpzioniConfigurazione:new Array(),
            arrayOpzioniConfigurazioneDefault : new Array(
                {
                    titolo:"Testi",
                    icona:'',
                    visible:false,
                    id:1,
                    opzioni: new Array(
                        {ID_OPZIONE_BASE:171, ETICHETTA:'Orari',                            LABEL:'ORARI',          TYPE:"TEXTAREA",    VALORE:'-',     COL:'col-12',  CLASSE_CTRL:'input-sm active',       ROWS:'8',   GROUP:1,    ICON: ''    },
                        {ID_OPZIONE_BASE:172, ETICHETTA:'Foot1',                            LABEL:'FOOT_1',         TYPE:"TEXTAREA",    VALORE:'-',     COL:'col-12',  CLASSE_CTRL:'input-sm',              ROWS:'8',   GROUP:1,    ICON: ''    },
                        {ID_OPZIONE_BASE:173, ETICHETTA:'Foot2',                            LABEL:'FOOT_2',         TYPE:"TEXTAREA",    VALORE:'-',     COL:'col-12',  CLASSE_CTRL:'input-sm',              ROWS:'8',   GROUP:1,    ICON: ''    },
                        {ID_OPZIONE_BASE:174, ETICHETTA:'Foot3',                            LABEL:'FOOT_3',         TYPE:"TEXTAREA",    VALORE:'-',     COL:'col-12',  CLASSE_CTRL:'input-sm',              ROWS:'8',   GROUP:1,    ICON: ''    },
                        {ID_OPZIONE_BASE:175, ETICHETTA:'Copyright',                        LABEL:'COPYRIGHT',      TYPE:"TEXTAREA",    VALORE:'-',     COL:'col-12',  CLASSE_CTRL:'input-sm',              ROWS:'8',   GROUP:1,    ICON: ''    },
                        {ID_OPZIONE_BASE:176, ETICHETTA:'Covid-19',                         LABEL:'COVID_19',       TYPE:"TEXTAREA",    VALORE:'-',     COL:'col-12',  CLASSE_CTRL:'input-sm',              ROWS:'8',   GROUP:1,    ICON: ''    },
                        {ID_OPZIONE_BASE:177, ETICHETTA:'Green Pass',                       LABEL:'GREEN_PASS',     TYPE:"TEXTAREA",    VALORE:'-',     COL:'col-12',  CLASSE_CTRL:'input-sm',              ROWS:'8',   GROUP:1,    ICON: ''    },
                    )
                },
                {
                    titolo:"Custom",
                    icona:'',
                    visible:false,
                    id:2,
                    opzioni: new Array(
                        {ID_OPZIONE_BASE:181, ETICHETTA:'Custom 1',                         LABEL:'CUSTOM_1',   TYPE:"TEXTAREA",    VALORE:'-',     COL:'col-12',  CLASSE_CTRL:'input-sm active',       ROWS:'8',   GROUP:1,    ICON: ''    },
                        {ID_OPZIONE_BASE:182, ETICHETTA:'Custom 2',                         LABEL:'CUSTOM_2',   TYPE:"TEXTAREA",    VALORE:'-',     COL:'col-12',  CLASSE_CTRL:'input-sm',              ROWS:'8',   GROUP:1,    ICON: ''    },
                        {ID_OPZIONE_BASE:183, ETICHETTA:'Custom 3',                         LABEL:'CUSTOM_3',   TYPE:"TEXTAREA",    VALORE:'-',     COL:'col-12',  CLASSE_CTRL:'input-sm',              ROWS:'8',   GROUP:1,    ICON: ''    },
                        {ID_OPZIONE_BASE:184, ETICHETTA:'Custom 4',                         LABEL:'CUSTOM_4',   TYPE:"TEXTAREA",    VALORE:'-',     COL:'col-12',  CLASSE_CTRL:'input-sm',              ROWS:'8',   GROUP:1,    ICON: ''    },
                        {ID_OPZIONE_BASE:185, ETICHETTA:'Custom 5',                         LABEL:'CUSTOM_5',   TYPE:"TEXTAREA",    VALORE:'-',     COL:'col-12',  CLASSE_CTRL:'input-sm',              ROWS:'8',   GROUP:1,    ICON: ''    },
                        {ID_OPZIONE_BASE:186, ETICHETTA:'Custom 6',                         LABEL:'CUSTOM_6',   TYPE:"TEXTAREA",    VALORE:'-',     COL:'col-12',  CLASSE_CTRL:'input-sm',              ROWS:'8',   GROUP:1,    ICON: ''    },
                        {ID_OPZIONE_BASE:187, ETICHETTA:'Custom 7',                         LABEL:'CUSTOM_7',   TYPE:"TEXTAREA",    VALORE:'-',     COL:'col-12',  CLASSE_CTRL:'input-sm',              ROWS:'8',   GROUP:1,    ICON: ''    },
                        {ID_OPZIONE_BASE:188, ETICHETTA:'Custom 8',                         LABEL:'CUSTOM_8',   TYPE:"TEXTAREA",    VALORE:'-',     COL:'col-12',  CLASSE_CTRL:'input-sm',              ROWS:'8',   GROUP:1,    ICON: ''    },
                        {ID_OPZIONE_BASE:189, ETICHETTA:'Custom 9',                         LABEL:'CUSTOM_9',   TYPE:"TEXTAREA",    VALORE:'-',     COL:'col-12',  CLASSE_CTRL:'input-sm',              ROWS:'8',   GROUP:1,    ICON: ''    },
                        {ID_OPZIONE_BASE:190, ETICHETTA:'Custom 10',                        LABEL:'CUSTOM_10',  TYPE:"TEXTAREA",    VALORE:'-',     COL:'col-12',  CLASSE_CTRL:'input-sm',              ROWS:'8',   GROUP:1,    ICON: ''    },
                    )
                },

            ),
        }
    },

    methods: {
        getOpzioni : function(activeTab){
            utils.get(this.apiStartup,{activeTab:activeTab}, (response) => {
                var arrayOpzioni = response.data;
                this.arrayOpzioniConfigurazione = utils.clone(this.arrayOpzioniConfigurazioneDefault);
                for (var i = 0 ; i < this.arrayOpzioniConfigurazione.length ; i++){
                    for (var j = 0 ; j < this.arrayOpzioniConfigurazione[i].opzioni.length ; j++){
                        //this.arrayOpzioniConfigurazione[i].opzioni[j].CLASSE_CTRL = '';
                        this.arrayOpzioniConfigurazione[i].opzioni[j].VMODEL = 'VALORE';
                        this.arrayOpzioniConfigurazione[i].opzioni[j].ID_OPZIONE = 0;
                        for (var k = arrayOpzioni.length-1 ; k > -1  ; --k){
                            if (this.arrayOpzioniConfigurazione[i].opzioni[j].ID_OPZIONE_BASE == arrayOpzioni[k].ID_OPZIONE_BASE){
                                this.arrayOpzioniConfigurazione[i].opzioni[j].VALORE = arrayOpzioni[k].VALORE;
                                this.arrayOpzioniConfigurazione[i].opzioni[j].ID_OPZIONE = arrayOpzioni[k].ID_OPZIONE;
                                arrayOpzioni.splice(k,1);
                                break;
                            }
                        }
                    }
                }              

                //AGGIUNGO LE OPZIONI CUSTOM DEL SITO
                for (var i = 0 ; i < this.arrayOpzioniConfigurazione.length ; i++){
                    if (this.arrayOpzioniConfigurazione[i].id == 100){
                        for (var j = 0 ; j < arrayOpzioni.length ; j++){
                            this.arrayOpzioniConfigurazione[i].opzioni.push({LABEL:arrayOpzioni[j].LABEL,VALORE:arrayOpzioni[j].VALORE,TYPE:'TEXTAREA',ID_OPZIONE:arrayOpzioni[j].ID_OPZIONE});
                        }
                        this.$forceUpdate();
                        break;
                    }
                }

            });
        },        

        salvaOpzioni : function(){
            var arr = new Array();
            for (var i = 0 ; i < this.arrayOpzioniConfigurazione.length ; i++){
                for (var j = 0 ; j < this.arrayOpzioniConfigurazione[i].opzioni.length ; j++){
                    arr.push(this.arrayOpzioniConfigurazione[i].opzioni[j]);
                }
            }
            for (var i = 0 ; i < this.arrayOpzioniCustom.length ; i++){
                arr.push(this.arrayOpzioniCustom[i]);
            }
            utils.put('core/opzioni/update',{opzioni:arr,ID_ENTE:this.idEnteCorrente}, (response) => {
                if (response.esito == 0){
                    utils.alert.success(response.messaggio);
                    this.getOpzioni();
                }
            });
        },

        getConfigurazioniEnte : function(){
            this.getOpzioni(this.activeTab);
        },

        refreshEnte : function(){
            this.idEnteCorrente = this.$root.idEnteCorrente;
            this.getOpzioni(this.idEnteCorrente);
        },

        nuovaOpzioneCustom(){
            this.arrayOpzioniCustom.push({ID_OPZIONE_BASE:0, ETICHETTA:'-',LABEL:'-',TYPE:"TEXTAREA",VALORE:'-', COL:'col-12 col-md-6',CLASSE_CTRL:'',GROUP:1,ICON: 'far fa-ballot-check'},);
        },

    },

    computed: {
        uploadDisabled() {
            return this.files.length === 0;
          }
    },

    beforeCreate : function(){
        setTimeout(() => {
            global.utils.deltaGriglia = 100;   
            global.utils.resizeContent();     
        }, 300);
    },
    
    unmounted : function(){
       global.utils.deltaGriglia = 0;
    },

    created: function () {
       this.idEnteCorrente = this.$root.idEnteCorrente;
       this.getOpzioni(this.idEnteCorrente);
    },

}
</script>